/* unplugin-vue-components disabled */import script from "./LogoIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./LogoIcon.vue?vue&type=script&setup=true&lang=ts"

import "./LogoIcon.vue?vue&type=style&index=0&id=b296a8bc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b296a8bc"]])

export default __exports__